// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3HBzh","Label":"Input_Label__3Qg_v","InputElement":"Input_InputElement__2DW3x","Invalid":"Input_Invalid__2GXy7"};